import { OptionsType } from '../../issue/maturity';
import { FilterResultFacade } from '../filter-result-facade';
import {
  AdvancedFilterName,
  FilterOptions,
  FilterPassParams,
  InclusiveExclusiveFilterModel
} from '../filter-types';
import { FilterHandlerBase } from './base/filter-handler-base';

export class SubordinateAdvancedFilterHandler extends FilterHandlerBase {
  get name(): string {
    return AdvancedFilterName.subordinate;
  }

  get isInclusiveExclusive(): boolean {
    return false;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getFilterOptions(filterOptions: FilterOptions): any {
    return filterOptions.subordinates;
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    const subordinate = params.filters[this.name];
    const data = params.deal;
    let isSubordinateFilterPassed = true;

    if (subordinate && subordinate.model) {
      const subordinateFilterModel = subordinate.model as InclusiveExclusiveFilterModel;
      const filterValues = subordinateFilterModel.values;

      if (data && data.series.length) {
        const filterBlank = filterValues
          ? filterValues.indexOf(OptionsType.Blank) !== -1
          : false;

        isSubordinateFilterPassed = data.series.some(({ structure }) => {
          let seriesHasValue = !!filterValues.find(
            (value) => value === structure
          );

          seriesHasValue =
            !seriesHasValue && !structure && filterBlank
              ? true
              : seriesHasValue;

          return seriesHasValue;
        });
      }
    }

    result.applyDealFilerResult(data.id, this.name, isSubordinateFilterPassed);

    return isSubordinateFilterPassed;
  }
}
